import React, {useState, useEffect} from "react";
import {connect} from "react-redux";
import axios from "axios";
import {serverLink} from "../../resources/url";
import {useNavigate} from "react-router-dom";
import {toast} from "react-toastify";
import {setApplicationDetails, setGeneralDetails, setLoginDetails} from "../../actions/actions";
import Header from "../common/header/header";
import Sidebar from "../common/sidebar/sidebar";
function AdmissionType(props) {
    const [userData] = useState(props.applicationLogin);
    const [IsLoading, setIsLoading] = useState(false)
    const [isFormLoading, setisFormLoading] = useState('off')
    const navigate = useNavigate();
    // const [appDetail, setAppDetail] = useState([]);
    const [loading, setLoading] = useState(true);
    const [selection, setSelection] = useState({
        ApplicationID: props.applicationData.EntryID,
        hostel: "",
        admissionType: "",
    });

     const [shouldSave, setShouldSave] = useState(false);

    const handleChange = (e) => {
        setSelection({ ...selection, [e.target.id]: e.target.value });
        setShouldSave(true);
    };

    const getData = async () => {
        await axios
            .get(
                `${serverLink}application/application-select/${props.applicationData.EntryID}`
            )
            .then((response) => {
                if (response.data.data.length > 0) {
                    setSelection({
                        ...selection,
                        hostel: response.data.data[0].IsHostelRequired,
                        admissionType: response.data.data[0].AdmissionType
                    })
                     setShouldSave(true);
                }
                // setAppDetail(response.data);
                setLoading(false);
            })
            .catch((error) => {
                console.log(error);
            });
    };
    useEffect(() => {
        getData();
    }, []);

    const handleSubmit = async (e) => {
        e.preventDefault();
        for (let value in selection) {
            if (selection.hasOwnProperty(value) && value !== "hostel") {
                if (selection[value] === "" || selection[value] === null) {
                    toast.error(`${value} can't be empty`);
                    return false;
                }
            }
        }
        if (shouldSave) {
            setisFormLoading('on')
            toast.info(`Submitting... Please wait!`);
            if (selection.hostel === "") setSelection({ ...selection, hostel: "No" });
            await axios
                .patch(`${serverLink}application/update-applicant`, selection)
                .then((res) => {
                    if (res.data.message === "success") {
                        allApplicationData();
                        toast.success(`Information Submitted Successfully`);
                        onNext();
                        setisFormLoading('off')
                    } else
                        toast.error(
                            `Something went wrong. Please check your connection and try again!`
                        );
                    setisFormLoading('off')
                })
                .catch((error) => {
                    console.log("NETWORK ERROR", error);
                });
         }
    };

    const onPrevious = () => {
        navigate("/undergraduate/dashboard");
    };

    const onNext = () => {
        navigate("/undergraduate/personal-information");
    };

    async function allApplicationData() {
        axios
            .get(
                `${serverLink}application/ug/application/data/${props.applicationData.EntryID}`
            )
            .then((response) => {
                 props.setOnGeneralDetails(response.data);
            })
            .catch((error) => {
                console.log(error);
            });
    }

    useEffect(() => {
        if (props.applicationLogin.length === 0)
            navigate("/login");
    }, [props.applicationLogin]);

    return (
        // loading ?
        //     <Loader/>
        //     :
            <>
                <div className="main-wrapper">
                    <Header/>
                    <Sidebar/>
                    <div className="page-wrapper">
                        <div className="content">
                <div className="d-md-flex d-block align-items-center justify-content-between mb-3">
                    <div className="d-md-flex d-block align-items-center justify-content-between mb-3">
                        <div className="my-auto mb-2">
                            <h3 className="page-title mb-1">Welcome, {`${userData.FirstName} ${userData.MiddleName} ${userData.Surname}`
                            }</h3>
                            <nav>
                                <ol className="breadcrumb mb-0">
                                    <li className="breadcrumb-item">
                                        <a href="">Dashboard</a>
                                    </li>
                                    <li className="breadcrumb-item active" aria-current="page">Admission Type</li>
                                </ol>
                            </nav>
                        </div>
                    </div>
                </div>
                <div className="row justify-content-center">
                    <div className="col-md-8 d-flex justify-content-center align-items-center min-vh-50">
                        <div className="flex-fill">
                            <br />
                            <form className="login bg-white shadow p-5" onSubmit={handleSubmit}>
                                <div className="mb-3">
                                    <h5><b>Select Preferred Options</b></h5>
                                </div>

                                <div className="row gy-4">
                                    {/* Hostel Selection */}
                                    <div className="col-sm-6">
                                        <label htmlFor="hostel" className="form-label">
                                            Hostel <span className="text-danger">*</span>
                                        </label>
                                        <select id="hostel" className="form-control" onChange={handleChange} value={selection.hostel}>
                                            <option value="">Select Option</option>
                                            <option value="Yes">Yes</option>
                                            <option value="No">No</option>
                                        </select>
                                    </div>

                                    {/* Admission Type Selection */}
                                    <div className="col-sm-6">
                                        <label htmlFor="admissionType" className="form-label">
                                            Admission Type <span className="text-danger">*</span>
                                        </label>
                                        <select id="admissionType" className="form-control" onChange={handleChange} value={selection.admissionType}>
                                            <option value="">Select Option</option>
                                            <option value="UTME">UTME</option>
                                            <option value="Direct Entry">Direct Entry</option>
                                            <option value="Transfer">Transfer</option>
                                            <option value="Foundation">Foundation</option>
                                            <option value="IJMB">IJMB</option>
                                        </select>
                                    </div>
                                </div>

                                {/* Buttons */}
                                <div className="col-md-12 mt-5">
                                    {isFormLoading === 'on' ?
                                        <button className="btn btn-dark text-center offset-3 w-50" id="kt_modal_new_address_submit">
                                                    <span className="indicator-progress">Please wait...
                                                    <span className="spinner-border spinner-border-sm align-middle ms-2" />
                                                </span>
                                        </button>
                                        :
                                        <div className="filters-group mb-lg-4 text-center">
                                            <button className="btn btn-dark mx-2" onClick={onPrevious}>Previous</button>
                                            <button className="btn btn-dark w-50 mx-2" type="submit">
                                                Save and Continue
                                            </button>
                                        </div>
                                    }
                                </div>
                            </form>
                        </div>
                    </div>
                </div>
                            {/*<Footer/>*/}
                        </div>
                    </div>
                </div>
            </>
    );
}

const mapStateToProps = (state) => {
    return {
        applicationLogin: state.loginDetails,
        applicationData: state.applicationDetails,
    };
};

const mapDispatchToProps = (dispatch) => {
    return {
        setOnLoginDetails: (p) => {
            dispatch(setLoginDetails(p));
        },
        setOnGeneralDetails: (p) => {
            dispatch(setGeneralDetails(p));
        },
    };
};

export default connect(mapStateToProps, mapDispatchToProps)(AdmissionType);
